//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import Cuid from '@models/Cuid';

export const curalateShortlinkPrefix = 'https://cur.lt/';

export enum SourceType {
  DataSource = 'data_source',
  DynamicLandingPage = 'dlp',
  Experience = 'experience',
  FacebookPost = 'fb_post',
  IgPromotedPost = 'ig_promoted_post',
  IgShopping = 'ig_shopping',
  IgStory = 'ig_story',
  Like2Buy = 'like2buy',
  Reels = 'reels',
  Reveal = 'reveal',
  Shortlink = 'shortlink',
  Tilt = 'tilt',
  TrendingProducts = 'trending_products',
  Tributary = 'tributary',
  TwitterPost = 'twitter_post',
}

export interface IAugmentSwipeUpLinkRequest {
  url: string;
  cuid: Cuid;
}

export interface IAugmentSwipeUpLinkResponse {
  data: string;
}

export interface IShortenUrlRequest {
  url: string;
  cuid?: Cuid;
  sourceType?: SourceType;
}

export type ITrackingShortLinkBody =
  | {
      url: string;
      sourceType: SourceType.FacebookPost;
      reserveId?: never;
    }
  | {
      url: string;
      sourceType: Exclude<SourceType, SourceType.FacebookPost>;
      // the unique id added to the tracking parameter embedded
      // in the target url, commonly the cuid. Optional for posts that
      // add their own unique ids on the backend
      reserveId?: string;
    };

export interface IShortenUrlResponse {
  data: string;
}

export interface IGetDestinationUrlRequest {
  shortlink: string;
}

export interface IGetDestinationUrlResponse {
  data: string | undefined;
}

export interface IGetDestinationUrlsRequest {
  links: string[];
}

export interface IGetDestinationUrlsResponse {
  data: Record<string, string>;
}
